import { ComponentProps } from 'react'

import { DaytimePage } from '@factorialco/f0-react/dist/experimental'

const sunriseMinutes = 6 * 60 // 6:00 AM
const middayMinutes = 12 * 60 // 12:00 PM
const sunsetMinutes = 18 * 60 // 6:00 PM

export const getMomentOfDay = () => {
  const today = new Date()
  const hour = today.getHours()
  const minutes = today.getMinutes()
  const currentMinutes = hour * 60 + minutes

  if (currentMinutes >= sunriseMinutes && currentMinutes < middayMinutes) {
    return 'morning' as const
  } else if (currentMinutes >= middayMinutes && currentMinutes < sunsetMinutes) {
    return 'afternoon' as const
  }

  return 'evening' as const
}

export type MomentOfDay = ComponentProps<typeof DaytimePage>['period']
